import { CartLinesUpdateEvent } from '@shopify/events';

const root = document.querySelector('.legacy-content');

// Ask the existing legacy add request for the HTML consumed by V2's cart.
// Without it, V2 can open the drawer before its fallback section read finishes.
if (root) {
  document.addEventListener('cart:prepare-bundled-sections', (event) => {
    const sections = event.detail?.sections;
    if (!Array.isArray(sections)) return;
    for (const component of document.querySelectorAll('cart-items-component')) {
      const id = component.dataset.sectionId;
      if (id && !sections.includes(id)) sections.push(id);
    }
  });
}

// The legacy form already added these items. Notify V2 without another cart write.
root?.addEventListener('variant:add', (event) => {
  const cart = event.detail?.cart;
  const items = event.detail?.items;
  if (!cart || !Array.isArray(items) || items.length === 0) return;

  const lines = event.detail.addedLines ?? items.map((item) => ({
    merchandiseId: String(item.variant_id ?? item.id),
    quantity: item.quantity,
  }));
  const pending = CartLinesUpdateEvent.createPromise();
  event.target.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines,
    promise: pending.promise,
  }));

  pending.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: {
      source: 'legacy-product-form',
      items: cart.items,
      addedItems: items,
      itemCount: lines.reduce((count, line) => count + line.quantity, 0),
      sections: cart.sections,
      didError: false,
    },
  });
});
